import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
// `sb_publishable_` é a chave pública atual do Supabase. Mantemos o nome
// antigo como fallback para não quebrar instalações já configuradas.
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Check if we have valid Supabase credentials
const isValidUrl = (url: string): boolean => {
    try {
        new URL(url);
        return url.startsWith('http://') || url.startsWith('https://');
    } catch {
        return false;
    }
};

const hasValidCredentials = isValidUrl(supabaseUrl) && supabasePublishableKey.length > 10;

// Only create client if we have valid credentials
export const supabase: SupabaseClient | null = hasValidCredentials
    ? createClient(supabaseUrl, supabasePublishableKey)
    : null;

export const isDemoMode = !hasValidCredentials;

if (!hasValidCredentials) {
    if (!supabaseUrl || !supabasePublishableKey) {
        console.warn('⚠️ SUPABASE MISSING: VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set in Environment Variables.');
    } else if (!isValidUrl(supabaseUrl)) {
        console.warn('⚠️ SUPABASE INVALID: VITE_SUPABASE_URL is not a valid URL.');
    }
    console.log('🎮 Hiva AIStudio running in DEMO mode (no Supabase credentials)');
}
